import { usePathname, useSearchParams } from "next/navigation";

export function useRegisterNextParams() {
    const pathname = usePathname();
    const params = useSearchParams();
    const registerParams = new URLSearchParams({ next: `${pathname}${params.toString().length > 0 ? "?" + params.toString() : ""}` });
    return registerParams.toString();
}
